import React from 'react'
import tw from 'tailwind-styled-components'

const TwLinkHandle = tw.div`
  w-10
  h-24
  cursor-pointer
`

export interface LinkHandleProps {
  className?: string
  style?: React.CSSProperties
  onMouseDown?: (e: React.MouseEvent) => void
}

// svg inside a react component to simplify working w/ fill/stroke color classes
export const LinkHandle = ({
  className,
  style,
  onMouseDown
}: LinkHandleProps) => (
  <TwLinkHandle className={className} style={style} onMouseDown={onMouseDown}>
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute block left-0 top-8"
    >
      <path d="M0 4H5" strokeWidth="2" className="stroke-action-default" />
      <circle cx="6" cy="4" r="4" className="fill-action-default" />
      <circle cx="6" cy="4" r="2" className="fill-icon-invert" />
    </svg>
  </TwLinkHandle>
)
